import { useEffect } from 'react';

import { LoadingWrapper } from '../LoadingFinalStep/LoadingFinalStep.styles';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { useProfile } from '@/store';

export const LoadingContract = () => {
  const { profile, refetch } = useProfile();

  useEffect(() => {
    if (!profile) return;
    const interval = setInterval(() => {
      const ready =
        profile.legalId &&
        profile.birthday &&
        profile.tags?.length &&
        profile.name &&
        profile.lastName &&
        profile.email;

      if (!ready) {
        refetch();
      }
    }, 1500);

    return () => clearInterval(interval);
  }, [profile, refetch]);

  return (
    <LoadingWrapper>
      <LoadingCircleSpinner />
    </LoadingWrapper>
  );
};
